import { css, cva } from '@/styled-system/css';

const trackStyles = css.raw({
  height: 'Range.Track.height',
  background: 'Range.Track.bg.default',
  borderRadius: 'Range.Track',
  cursor: 'pointer',
  width: '100%',
});

const thumbStyles = css.raw({
  width: 'Range.Handle',
  height: 'Range.Handle',
  background: 'Range.Handle.bg.default',
  borderColor: 'Range.Handle.border.default',
  borderStyle: 'solid',
  borderWidth: 'Range.Handle',
  borderRadius: 'Range.Handle',
  boxShadow: 'Range.Handle.default',
  cursor: 'grab',
  position: 'relative',
  display: 'flex',
  marginTop: 'calc({spacing.Range.Handle.margin.top} * -1)',
  appearance: 'none',
  boxSizing: 'border-box',
  transition: {
    _motionReduce: 'none',
    _motionSafe: 'box-shadow 200ms ease',
  },
});

const thumbActiveStyles = css.raw({
  _active: {
    background: 'Range.Handle.bg.pressed',
    borderColor: 'Range.Handle.border.pressed',
    boxShadow: '{shadows.focus}, {shadows.Range.Handle.default}',
    cursor: 'grabbing',
  },
});

const thumbHoverStyles = css.raw({
  _hover: {
    background: 'Range.Handle.bg.hover',
    boxShadow: 'Range.Handle.hover',
    borderColor: 'Range.Handle.border.hover',
  },
});

const thumbFocusStyles = css.raw({
  'outline': 'none',
  'boxShadow': '{shadows.Range.Handle.default}, {shadows.focus}',
  'borderColor': 'Range.Handle.border.active',
  'background': 'Range.Handle.bg.active',

  '&:is(:hover)': {
    borderColor: 'Range.Handle.border.activeHover',
    background: 'Range.Handle.bg.activeHover',
  },
});

export const rangeRecipe = cva({
  base: {
    'appearance': 'none',
    'height': 'auto',
    'width': '100%',
    'marginBlock': 'Range.Root.margin.vert',
    'border': '0',
    'outline': 'none',

    '_focusVisible': {
      '&::-webkit-slider-thumb': {
        ...thumbFocusStyles,
      },

      '&::-moz-range-thumb': {
        ...thumbFocusStyles,
      },
    },

    '&::-webkit-slider-runnable-track': {
      ...trackStyles,
    },

    '&::-moz-range-track': {
      ...trackStyles,
    },

    '&::-webkit-slider-thumb': {
      ...thumbStyles,
    },

    '&::-moz-range-thumb': {
      ...thumbStyles,
    },
  },
  variants: {
    disabled: {
      true: {
        'opacity': 'disabled',

        '&::-webkit-slider-runnable-track': {
          cursor: 'auto',
        },

        '&::-moz-range-track': {
          cursor: 'auto',
        },

        '&::-webkit-slider-thumb': {
          cursor: 'auto',
        },

        '&::-moz-range-thumb': {
          cursor: 'auto',
        },
      },
      false: {
        '&::-webkit-slider-thumb': {
          ...thumbHoverStyles,
          ...thumbActiveStyles,
        },

        '&::-moz-range-thumb': {
          ...thumbHoverStyles,
          ...thumbActiveStyles,
        },
      },
    },
  },
});
